import React from 'react';
import Suggestions from 'design-system/suggestions/Suggestions';
const data = [
    {
        emoji: '🏖',
        name: 'Holidays',
    },
    {
        emoji: '🎁',
        name: 'Gift',
    },
    {
        emoji: '📚',
        name: 'Education',
    },
    {
        emoji: '🏡',
        name: 'House deposit',
    },
    {
        emoji: '📊',
        name: 'Future investor',
    },
    {
        emoji: '🏠',
        name: 'Home improvements',
    },
    {
        emoji: '🌧',
        name: 'Rainy day fund',
    },
    {
        emoji: '🍦',
        name: 'Treat yourself',
    },
    {
        emoji: '🏎',
        name: 'Nice car',
    },
    {
        emoji: '🚨',
        name: 'Emergency fund',
    },
];
const PotSuggestions = ({ name, selectedEmoji, handleSuggestionPress }) => (<Suggestions title="Pot suggestions" name={name} data={data} suggestedData={{
        name,
        emoji: selectedEmoji,
    }} handleSuggestionPress={handleSuggestionPress}/>);
export default React.memo(PotSuggestions);
